import { MEASUREMENT_TECHNIQUE } from './guideline';
import getTimeToProgression from './endpoints/getTimeToProgression';
import getTimeToResponse from './endpoints/getTimeToResponse';
import getDurationOfResponse from './endpoints/getDurationOfResponse';
import getBestOverallResponse from './endpoints/getBestOverallResponse';

export default function getEndpointsFromAssessments(criteria, ai_assessments) {
  if (ai_assessments.length === 0) return {};
  const keyMap = {
    [MEASUREMENT_TECHNIQUE.BIDIMENSIONAL]: 'sumDiameter',
    [MEASUREMENT_TECHNIQUE.VOLUMETRIC]: 'sumVolume',
  };
  const key = keyMap[criteria.measurementTechnique];
  const reports = ai_assessments.map(t => ({
    date: t.SeriesDate,
    changeFromBaseline: t.targetStat.fromBaseline[key],
    result: t.overallResponse.result,
  }));
  const timeToProgression = getTimeToProgression(reports);
  const timeToResponse = getTimeToResponse(reports);
  const durationOfResponse = getDurationOfResponse(reports);
  const bestOverallResponse = getBestOverallResponse(
    reports,
    criteria.completeResponseConfirmation === 'REQUIRED',
    criteria.minStableDiseaseDuration || 0
  );
  return {
    timeToProgression,
    timeToResponse,
    durationOfResponse,
    bestOverallResponse,
  };
}
